import React, { Fragment, useState } from 'react';
import { FaRegFileAlt, FaShieldAlt, FaLock, FaExclamationTriangle } from 'react-icons/fa';
import { MdSend, MdCheckCircle } from 'react-icons/md';
import Swal from 'sweetalert2';

import clienteAxios from '../../config/axios';

const CATEGORIAS = [
    'Cohecho o soborno',
    'Lavado de activos',
    'Financiamiento del terrorismo',
    'Receptación',
    'Negociación incompatible',
    'Corrupción entre particulares',
    'Administración desleal',
    'Apropiación indebida',
    'Fraude al Fisco',
    'Acoso laboral o sexual',
    'Discriminación arbitraria',
    'Conflicto de interés',
    'Uso indebido de información o recursos',
    'Incumplimiento de normas internas',
    'Otra situación irregular',
];

const AREAS = [
    'Administración',
    'Operaciones',
    'Ventas / Comercial',
    'Bodega / Logística',
    'Taller / Producción',
    'Gerencia',
    'Recursos Humanos',
    'Contabilidad / Finanzas',
    'No lo sé / Prefiero no indicar',
];

const COMO_ENTERADO = [
    'Soy testigo directo de los hechos',
    'Soy víctima de los hechos',
    'Me lo contó un tercero',
    'Lo inferí por indicios',
    'Otro medio',
];

const estadoInicial = {
    categoria: '',
    area: '',
    fechaAproximada: '',
    descripcion: '',
    comoSeEntero: '',
    medidasSolicitadas: '',
};

function CanalDenuncias() {

    const [denuncia, guardarDenuncia] = useState(estadoInicial);
    const [enviando, setEnviando] = useState(false);
    const [enviado, setEnviado] = useState(false);
    const [aceptaTerminos, setAceptaTerminos] = useState(false);

    const actualizarState = e => {
        guardarDenuncia({
            ...denuncia,
            [e.target.name]: e.target.value,
        });
    };

    const validarForm = () => {
        const { categoria, area, descripcion, comoSeEntero } = denuncia;
        return !categoria || !area || !descripcion.trim() || !comoSeEntero || !aceptaTerminos;
    };

    const enviarDenuncia = async e => {
        e.preventDefault();

        if (enviando) return;

        const confirmacion = await Swal.fire({
            title: '¿Confirma el envío de su denuncia?',
            html: `
                <p style="font-size:1.4rem; color:#555; margin-bottom:10px;">
                    Su denuncia será tratada de forma <strong>estrictamente confidencial</strong>.<br/>
                    No se almacenará ningún dato que permita identificar su identidad.
                </p>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, enviar denuncia',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#005ea1',
            cancelButtonColor: '#969696',
        });

        if (!confirmacion.isConfirmed) return;

        setEnviando(true);

        const payload = {
            categoria: denuncia.categoria,
            area: denuncia.area,
            fechaAproximada: denuncia.fechaAproximada || null,
            descripcion: denuncia.descripcion.trim(),
            comoSeEntero: denuncia.comoSeEntero,
            medidasSolicitadas: denuncia.medidasSolicitadas.trim() || null,
        };

        try {
            // await clienteAxios.post('/denuncias', payload);

            setEnviado(true);
            guardarDenuncia(estadoInicial);
            setAceptaTerminos(false);

        } catch (error) {
            console.error(error);
            // Swal.fire({
            //     icon: 'error',
            //     title: 'Error al enviar la denuncia',
            //     text: error?.response?.data?.mensaje || 'Ocurrió un error inesperado. Por favor intente nuevamente.',
            // });
        } finally {
            setEnviando(false);
        }
    };

    if (enviado) {
        return (
            <Fragment>
                <div className="card contenedor denuncias__exito">
                    <div className="denuncias__exito-icono">
                        <MdCheckCircle size={80} color="#14831483" />
                    </div>
                    <h1 className="denuncias__exito-titulo">Denuncia Recibida</h1>
                    <p className="denuncias__exito-texto">
                        Su denuncia ha sido enviada exitosamente. Será tratada con total confidencialidad
                        conforme a lo dispuesto en la <strong>Ley 21.595</strong> y las normas internas de la empresa.
                    </p>
                    <p className="denuncias__exito-subtexto">
                        No se almacenó ningún dato que permita identificar su identidad.
                    </p>
                    <button
                        className="btn-new btn-success-new"
                        onClick={() => setEnviado(false)}
                    >
                        Enviar otra denuncia
                    </button>
                </div>
            </Fragment>
        );
    }

    return (
        <Fragment>
            <div className="card contenedor">

                <div className="card-header denuncias__header">
                    <div className="denuncias__header-iconos">
                        <FaShieldAlt size={45} color="#005ea1" />
                        <FaRegFileAlt size={45} color="#333333" />
                    </div>
                    <h1>Canal de Denuncias Anónimo</h1>
                    <p className="denuncias__header-subtitulo">Impacto del Norte · Confidencial</p>
                </div>

                <div className="card-body">

                    <div className="denuncias__aviso">
                        <div className="denuncias__aviso-icono">
                            <FaLock size={22} color="#005ea1" />
                        </div>
                        <div className="denuncias__aviso-contenido">
                            <h3 className="denuncias__aviso-titulo">Garantía de Anonimato y Confidencialidad</h3>
                            <p className="denuncias__aviso-texto">
                                La empresa pone a disposición de sus trabajadores un canal confidencial para denunciar
                                hechos que puedan constituir infracciones a la <strong>Ley 21.595</strong> (Ley de Delitos
                                Económicos) u otras normas internas. Se asegura la <strong>reserva de identidad</strong> del
                                denunciante y la <strong>prohibición expresa de represalias</strong> en su contra.
                            </p>
                            <p className="denuncias__aviso-texto denuncias__aviso-texto--secundario">
                                Este formulario <strong>no almacena ningún dato</strong> que permita identificar al denunciante.
                                Su dirección IP, sesión activa u otro identificador no son registrados ni enviados junto a la denuncia.
                            </p>
                        </div>
                    </div>

                    <div className="denuncias__alerta">
                        <FaExclamationTriangle size={16} color="#bd8401" style={{ marginRight: '8px', flexShrink: 0, marginTop: '2px' }} />
                        <span>
                            Si los hechos denunciados constituyen un delito grave o existe peligro inmediato,
                            le instamos a contactar directamente a las autoridades competentes.
                        </span>
                    </div>

                    <h2 className="card-body-subtitle">Complete el formulario con el mayor detalle posible:</h2>

                    <form onSubmit={enviarDenuncia}>

                        <div className="campo">
                            <label htmlFor="categoria">
                                Categoría de la denuncia<span className="campo__obligatorio">*</span>:
                            </label>
                            <select
                                id="categoria"
                                name="categoria"
                                value={denuncia.categoria}
                                onChange={actualizarState}
                            >
                                <option value="">-- Seleccione una categoría --</option>
                                {CATEGORIAS.map(cat => (
                                    <option key={cat} value={cat}>{cat}</option>
                                ))}
                            </select>
                        </div>

                        <div className="campo">
                            <label htmlFor="area">
                                Área o departamento involucrado<span className="campo__obligatorio">*</span>:
                            </label>
                            <select
                                id="area"
                                name="area"
                                value={denuncia.area}
                                onChange={actualizarState}
                            >
                                <option value="">-- Seleccione un área --</option>
                                {AREAS.map(a => (
                                    <option key={a} value={a}>{a}</option>
                                ))}
                            </select>
                        </div>

                        <div className="campo">
                            <label htmlFor="comoSeEntero">
                                ¿Cómo se enteró de los hechos?<span className="campo__obligatorio">*</span>:
                            </label>
                            <select
                                id="comoSeEntero"
                                name="comoSeEntero"
                                value={denuncia.comoSeEntero}
                                onChange={actualizarState}
                            >
                                <option value="">-- Seleccione una opción --</option>
                                {COMO_ENTERADO.map(c => (
                                    <option key={c} value={c}>{c}</option>
                                ))}
                            </select>
                        </div>

                        <div className="campo">
                            <label htmlFor="fechaAproximada">
                                Fecha aproximada del hecho:
                            </label>
                            <input
                                type="date"
                                id="fechaAproximada"
                                name="fechaAproximada"
                                value={denuncia.fechaAproximada}
                                onChange={actualizarState}
                            />
                        </div>

                        <div className="campo">
                            <label htmlFor="descripcion">
                                Descripción de los hechos<span className="campo__obligatorio">*</span>:
                            </label>
                            <textarea
                                id="descripcion"
                                name="descripcion"
                                rows="8"
                                placeholder="Describa en detalle los hechos que desea denunciar: qué ocurrió, cuándo, dónde y quiénes estuvieron involucrados (puede omitir nombres si lo prefiere)."
                                value={denuncia.descripcion}
                                onChange={actualizarState}
                            />
                        </div>

                        <div className="campo">
                            <label htmlFor="medidasSolicitadas">
                                Medidas o acciones que solicita (opcional):
                            </label>
                            <textarea
                                id="medidasSolicitadas"
                                name="medidasSolicitadas"
                                rows="4"
                                placeholder="Indique si tiene alguna solicitud específica: investigación interna, medidas disciplinarias, auditoría, etc."
                                value={denuncia.medidasSolicitadas}
                                onChange={actualizarState}
                            />
                        </div>

                        <div className="denuncias__terminos">
                            <label className="denuncias__terminos-label">
                                <input
                                    type="checkbox"
                                    checked={aceptaTerminos}
                                    onChange={e => setAceptaTerminos(e.target.checked)}
                                    className="denuncias__terminos-check"
                                />
                                <span>
                                    Declaro que los hechos descritos son verídicos según mi conocimiento y entiendo que
                                    las denuncias de mala fe o con información falsa pueden tener consecuencias legales.
                                    Acepto que esta información sea tratada conforme a la política de privacidad de la empresa
                                    y a lo dispuesto en la <strong>Ley 21.595</strong>.
                                </span>
                            </label>
                        </div>

                        <div className="enviar">
                            <button
                                type="submit"
                                className={`btn-new ${!validarForm() ? 'btn-success-new' : ''} denuncias__btn-enviar`}
                                disabled={validarForm() || enviando}
                            >
                                <MdSend size={20} style={{ marginRight: '8px' }} />
                                {enviando ? 'Enviando...' : 'Enviar Denuncia Anónima'}
                            </button>
                        </div>

                        <p className="denuncias__pie">
                            <FaLock size={12} style={{ marginRight: '5px' }} />
                            Este canal es completamente anónimo. Ningún dato de identidad es almacenado o transmitido.
                        </p>

                    </form>
                </div>
            </div>
        </Fragment>
    );
}

export default CanalDenuncias;
